import { AuthenticationService } from '@cbuild/core';
import { Constructor } from '../utils/mixin.base';
import { Feature, SiteVisitFeaturePermissionMask } from './permission-enums';

// tslint:disable-next-line: typedef
export function PermissionBaseMixin<T extends Constructor>(base: T) {
  return class extends base {
    public authenticationService: AuthenticationService;
    public feature = Feature;
    public siteVisitFeaturePermissionMask = SiteVisitFeaturePermissionMask;

    // tslint:disable-next-line: no-any
    constructor(...args: Array<any>) {
      super();
      this.authenticationService = args[0];
    }
    public hasModulePermission(name: string): boolean {
      return this.authenticationService.hasModulePermission(name);
    }
    public hasUserPermission(
      appCode: string,
      requiredPermissionMask: number
    ): boolean {
      return this.authenticationService.hasUserPermission(
        appCode,
        requiredPermissionMask
      );
    }
  };
}
